import { render, staticRenderFns } from "./Not_found.vue?vue&type=template&id=a64a0fac&scoped=true"
import script from "./Not_found.vue?vue&type=script&lang=js"
export * from "./Not_found.vue?vue&type=script&lang=js"
import style0 from "./Not_found.vue?vue&type=style&index=0&id=a64a0fac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64a0fac",
  null
  
)

export default component.exports